import { render, staticRenderFns } from "./EditVoteProject.vue?vue&type=template&id=65011d9e"
import script from "./EditVoteProject.vue?vue&type=script&lang=js"
export * from "./EditVoteProject.vue?vue&type=script&lang=js"
import style0 from "./EditVoteProject.vue?vue&type=style&index=0&id=65011d9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports